import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiConfiguration } from '../api/api-configuration';
import {
  getAppointments$Json,
  GetAppointments$Json$Params
} from '../api/fn/calendar/get-appointments-json';
import {
  createAppointment$Json,
  CreateAppointment$Json$Params
} from '../api/fn/calendar/create-appointment-json';
import { CreateAppointmentRequest } from '../api/models/create-appointment-request';
import { Appointment } from '../api/models/appointment';

@Injectable({
  providedIn: 'root'
})
export class CalendarApiService {
  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfiguration
  ) {}

  /**
   * Gets User1's calendar events for the specified date range
   * User information is retrieved from JWT token in request header
   */
  getCalendarEvents(
    startDate: Date,
    endDate: Date
  ): Observable<Appointment[]> {
    const params: GetAppointments$Json$Params = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    };

    return getAppointments$Json(
      this.http,
      this.apiConfig.rootUrl,
      params
    ).pipe(
      map(response => response.body?.data || [])
    );
  }

  /**
   * Creates an appointment on User1's calendar
   * User information is retrieved from JWT token in request header
   */
  createAppointment(
    request: CreateAppointmentRequest
  ): Observable<Appointment> {
    const params: CreateAppointment$Json$Params = {
      body: request
    };

    return createAppointment$Json(
      this.http,
      this.apiConfig.rootUrl,
      params
    ).pipe(
      map(response => {
        if (!response.body?.data) {
          throw new Error('No data returned from API');
        }
        return response.body.data;
      })
    );
  }
}
